import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@/contexts/UserContext';
import { apiService } from '@/services/api';
import { resolveEncounterNavigation } from '@/utils/encounterNavigation';

export function useEncounterNavigation() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [pickerState, setPickerState] = useState(null);

  async function goToEncounter(encounterId) {
    try {
      const result = await resolveEncounterNavigation(encounterId, apiService, user?.id);
      if (result.type === 'pick') {
        setPickerState({ notes: result.notes, encounter: result.encounter });
      } else {
        navigate(result.path);
      }
    } catch (err) {
      console.error('Error navigating to encounter:', err);
      navigate(`/encounters/${encounterId}`);
    }
  }

  function handlePickerSelect(noteId) {
    navigate(`/clinical-notes/${noteId}/edit`);
    setPickerState(null);
  }

  function handlePickerClose() {
    if (pickerState?.encounter) {
      navigate(`/visits/${pickerState.encounter.id}`);
    }
    setPickerState(null);
  }

  return { goToEncounter, pickerState, handlePickerSelect, handlePickerClose };
}
